import { Routes, Route, Navigate } from 'react-router';
import routes from 'routes';

export default function AuthLayout() {
    const getRoutes = (routes: RoutesType[]): any => {
        return routes.map((route: RoutesType, key: any) => {
            if (route.layout === '/auth') {
                return (
                    <Route path={`${route.path}`} element={route.component} key={key} />
                );
            } else {
                return null;
            }
        });
    };

    return (
        <Routes>
            {getRoutes(routes)}
            <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
        </Routes>
    );
}
